import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function CancelPageStripe() {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <div className="flex flex-col items-center justify-center h-screen bg-gray-50 text-gray-700">
            <div className="bg-white shadow-xl rounded-2xl p-8 w-full max-w-md text-center">
                <h1 className="text-3xl font-bold text-red-600 mb-4">{t('paymentCancelled')}</h1>
                <p className="text-gray-600 mb-6">
                    {t('paymentIncomplete')}
                </p>
                <button onClick={() => navigate("/organization")} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition">
                    {t('back')}
                </button>
            </div>
        </div>
    );
}
